export const ValueOrDash = (value?: unknown) => {
  return value === "" ||
    value === null ||
    typeof value === "undefined" ||
    (typeof value == "number" && isNaN(value))
    ? "-"
    : value;
};
